<template>
  <a
    :href="link"
    class="pill__Tab mr-2"
    :class="{'pill__Tab-active' : isActive}"
    @click="setActiveTab(link)"
  >
    <aw-icon
      :icon="icon"
      class="mr-2.5 h-5 w-5 fill-current"
    />
    <span class="text-sm">
      {{ text }}
    </span>
  </a>
</template>

<script>
import { computed } from 'vue'
import activeTabPanelPill from './TabPanelPillContext'

export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: '#'
    },
    text: {
      type: String,
      default: ''
    },
    enableActiveByLink: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    activeTabPanelPill.value = null

    const isActive = computed(() => {
      if (!props.enableActiveByLink || !activeTabPanelPill.value) {
        return props.active
      }

      return activeTabPanelPill.value === props.link
    })

    const setActiveTab = (tab) => {
      if (props.enableActiveByLink) {
        activeTabPanelPill.value = tab
      }
    }

    return {
      isActive,
      setActiveTab,
    }
  },
}
</script>

<style lang="scss">
</style>
